import { getSupportedFieldConfiguration } from '@atlassian/ui-modifications-core/controllers';
import type { FieldForInitialize } from '@atlassian/ui-modifications-core/types';
import { REQUEST_CREATE_VIEW_TYPE } from '../../constants';
import type { FieldState } from 'state/persisted/request-create/types';
import type { RequestCreateViewFieldConfiguration } from './index';

interface GetValueByInitializeFieldPropertyMappingPayload<DEFAULT_VALUE> {
    field: FieldState;
    fieldType: string;
    property: keyof FieldForInitialize;
    defaultValue?: DEFAULT_VALUE;
}

export const getValueByInitializeFieldPropertyMapping = <RESULT, DEFAULT_VALUE = undefined>({
    field,
    fieldType,
    property,
    defaultValue = undefined,
}: GetValueByInitializeFieldPropertyMappingPayload<DEFAULT_VALUE>) => {
    const mappedProperty =
        getSupportedFieldConfiguration<RequestCreateViewFieldConfiguration>(REQUEST_CREATE_VIEW_TYPE, fieldType)
            ?.initializeFieldPropertyMapping?.[property] ?? property;

    return (field?.[mappedProperty as keyof FieldState] as RESULT) ?? defaultValue;
};
